import React, {useState} from 'react';
import {ARVisualization} from "./ARVisualization";
import {SCENE} from "./interfaces/UX";
import {Floor} from "./interfaces/Floor";
import {HtmlVisualization} from "./HtmlVisualization";
import {ErrorImpact, ErrorWrapper} from "./interfaces/ErrorHandling";
import {CriticalErrorVisualization} from "./CriticalErrorVisualization";


function App() {

    const [scene, setScene] = useState<SCENE>(SCENE.INIT);
    const [floors, setFloors] = useState<Floor[]>([]);
    const [error, setError] = useState<Error | null>(null);

    if (error) {
        return (<CriticalErrorVisualization error={error}/>);
    }

    const errorHandler = (error: ErrorWrapper) => {
        switch (error.impact) {
            case ErrorImpact.CRITICAL:
                console.error(error.error);
                setError(error.error);
                break;
            default:
                console.warn(error.error);
        }
    };

    const addFloorHandler = (floor: Floor) => {
        setFloors([...floors, floor]);
    };

    const changeScene = (scene: SCENE) => {
      setScene(scene);
    };

    return (
        <>
            <ARVisualization scene={scene} changeScene={changeScene} addFloor={addFloorHandler} onError={errorHandler} initialize={scene !== SCENE.INIT} />
            <HtmlVisualization scene={scene} changeScene={changeScene} onError={errorHandler} />
        </>
    );
}

export default App;
